var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomHalfTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 505,
    height: 554,
    viewBox: "0 0 505 554",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    width: 341,
    height: 554,
    rx: 25,
    fill: "#5E3B11"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 105,
    rx: 10,
    transform: "matrix(0 -1 -1 0 182 115)",
    fill: "#5E3B11"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 105,
    rx: 10,
    transform: "matrix(0 -1 -1 0 105 61)",
    fill: "#5E3B11"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 73,
    rx: 10,
    transform: "matrix(-1 0 0 1 105 42)",
    fill: "#5E3B11"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 96,
    width: 30,
    height: 200,
    rx: 10,
    fill: "#35220A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 53,
    width: 30,
    height: 125,
    rx: 10,
    fill: "#35220A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 196,
    width: 30,
    height: 25,
    rx: 10,
    fill: "#35220A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 42,
    width: 30,
    height: 125,
    rx: 10,
    fill: "#35220A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 334,
    width: 30,
    height: 125,
    rx: 10,
    fill: "#35220A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 393,
    y: 96,
    width: 30,
    height: 300,
    rx: 10,
    fill: "#35220A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 211,
    width: 30,
    height: 300,
    rx: 10,
    fill: "#35220A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomHalfTree);
export default __webpack_public_path__ + "static/media/BottomHalfTree.8f3483d8d4cebf69927acda529611881.svg";
export { ForwardRef as ReactComponent };